/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We may collect the following categories of information:`)
};

const es_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos recopilar las siguientes categorías de información:`)
};

const de_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir können die folgenden Kategorien von Informationen erfassen:`)
};

const nl_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We kunnen de volgende categorieën informatie verzamelen:`)
};

const fr_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous pouvons collecter les catégories d’informations suivantes :`)
};

const it_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potremmo raccogliere le seguenti categorie di informazioni:`)
};

const pt_br2_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos coletar as seguintes categorias de informações:`)
};

const pt_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos recolher as seguintes categorias de informação:`)
};

const ja_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下のカテゴリの情報を収集する場合があります:`)
};

const zh_privacy_section_2_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们可能收集以下类别的信息：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_2_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_2_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_2_intro", locale)
	if (locale === "en") return en_privacy_section_2_intro(inputs)
	if (locale === "es") return es_privacy_section_2_intro(inputs)
	if (locale === "de") return de_privacy_section_2_intro(inputs)
	if (locale === "nl") return nl_privacy_section_2_intro(inputs)
	if (locale === "fr") return fr_privacy_section_2_intro(inputs)
	if (locale === "it") return it_privacy_section_2_intro(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_2_intro(inputs)
	if (locale === "pt") return pt_privacy_section_2_intro(inputs)
	if (locale === "ja") return ja_privacy_section_2_intro(inputs)
	return zh_privacy_section_2_intro(inputs)
};